export const roles = {
  admin: 'admin',
  user: 'org_admin',
  org_user: 'org_user',
  labeler: 'labeler',
  analytics_user: 'analytics_user',
  workstation_user: 'workstation_user',
  support_user: 'support_user',
  doc_user: 'doc_user',
};

export const roleLabels = {
  [roles.admin]: 'Super Admin',
  [roles.user]: 'Organization Admin',
  [roles.org_user]: 'Organization User',
  [roles.labeler]: 'Labeler',
  [roles.analytics_user]: 'Analytics User',
  [roles.workstation_user]: 'Workstation User',
  [roles.support_user]: 'Support User',
  [roles.doc_user]: 'Docs User',
};

export const roleRoutes = {
  [roles.admin]: 'Organizations',
  [roles.user]: 'Dashboard',
  [roles.org_user]: 'Dashboard',
  [roles.support_user]: 'Dashboard',
  [roles.labeler]: 'Tasks Requested',
  [roles.analytics_user]: 'Analytics',
  [roles.doc_user]: 'User Manuals',
};

export const rolesDrawerItems = {
  [roles.admin]: [
    'Organizations',
    'All Users',
    'Roles',
    'Pending Users',
    'All Devices',
    'Archived Cycles',
    'All Operation',
    'Updates',
    'Instances',
    'Trained Operations',
    'Annotations',
    'Labelers',
    'Tampering Requests',
    'User Report',
    'Barcode',
    'AWS-Lambda Token',
    'Org Model Versions',
    'Model Types',
    'Task Categories',
    'Feature Control',
    'Event Notification',
  ],
  [roles.user]: [
    'Dashboard',
    'SETUP',
    'Add Device',
    'Define Operation',
    // 'IoT Pluginsᴮᴱᵀᴬ',
    'Record Training Set',
    'Label Training Set',
    'Train Model',
    'Deploy Model',
    // 'Ergonomics',
    'LEAN',
    'Analytics',
    'Operation Level Analytics',
    'Station Level Analytics',
    'Line Analytics',
    'Trace',
    'Cycle Trace',
    'Issue Center',
    'MANAGEMENT',
    'Devices',
    'Cameras',
    'Users',
    'Issue Center',
    'MANAGEMENT',
    'Devices',
    'Users',
    'OPC',
    'Line',
    'Line Visibility',
  ],
  [roles.org_user]: [
    'Dashboard',
    'SETUP',
    'Add Device',
    'Define Operation',
    // 'IoT Pluginsᴮᴱᵀᴬ',
    'Record Training Set',
    'Label Training Set',
    'Train Model',
    'Deploy Model',
    // 'Ergonomics',
    'LEAN',
    'Analytics',
    'Operation Level Analytics',
    'Station Level Analytics',
    'Line Analytics',
    'Trace',
    'Cycle Trace',
    'Issue Center',
    'MANAGEMENT',
    'Devices',
    'Cameras',
    'OPC',
    'Line',
    'Line Visibility',
  ],
  [roles.labeler]: ['Tasks Requested', 'Profile Setting'],
  [roles.analytics_user]: [
    'Analytics',
    'Operation Level Analytics',
    'Station Level Analytics',
    'Line Analytics',
    'Trace',
    'Cycle Trace',
    'Issue Center',
    'Line Visibility',
  ],
  [roles.support_user]: [
    'Dashboard',
    'SETUP',
    'Add Device',
    'Define Operation',
    // 'IoT Pluginsᴮᴱᵀᴬ',
    'Record Training Set',
    'Label Training Set',
    'Train Model',
    'Deploy Model',
    // 'Ergonomics',
    'LEAN',
    'Analytics',
    'Operation Level Analytics',
    'Station Level Analytics',
    'Line Analytics',
    'Trace',
    'Cycle Trace',
    'Issue Center',
    'MANAGEMENT',
    'Devices',
    'Cameras',
    'Users',
    'OPC',
    'Line',
    'Line Visibility',
  ],
  [roles.doc_user]: [
    'Dashboard',
    'SETUP',
    'Add Device',
    'Define Operation',
    // 'IoT Pluginsᴮᴱᵀᴬ',
    'Record Training Set',
    'Label Training Set',
    'Train Model',
    'Deploy Model',
    // 'Ergonomics',
    'LEAN',
    'Analytics',
    'Operation Level Analytics',
    'Station Level Analytics',
    'Line Analytics',
    'Trace',
    'Cycle Trace',
    'Issue Center',
    'MANAGEMENT',
    'Devices',
    'Cameras',
    'Users',
    'Line',
    'Line Visibility',
  ],
};
